import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AsyncPipe, DatePipe, NgClass, NgForOf, NgIf} from '@angular/common';
import {
  NgbDatepickerModule,
  NgbDropdown,
  NgbDropdownMenu,
  NgbDropdownModule,
  NgbModal
} from '@ng-bootstrap/ng-bootstrap';
import {SummaryModalComponent} from '../summary-modal/summary-modal.component';
import {environment} from '../../../environments/environment';
import {ReviewService} from '../review.service';
import moment from 'moment';
import {AuthService} from '../../auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {DisplayPipe} from '@shared/pipes/display.pipe';
import {HelpDocsLinksComponent} from '@shared/help-docs-links/help-docs-links.component';
import {ResultsListComponent} from '@shared/results-list/results-list.component';

@Component({
    selector: 'app-review-queue',
    templateUrl: './review-queue.component.html',
    styleUrls: ['./review-queue.component.css'],
    providers: [DatePipe, DisplayPipe, ReviewService],
    imports: [
        HelpDocsLinksComponent,
        NgClass,
        FormsModule,
        ResultsListComponent,
        NgbDatepickerModule,
        NgbDropdownModule,
        AsyncPipe,
        NgIf,
        NgForOf
    ]
})
export class ReviewQueueComponent implements OnInit, AfterViewInit {
  public searchObj: any = {};
  public loading = true;
  public metaCount: any = {};
  public open = {};
  public displayFields = ['site_name', 'content_type', 'sub_type', 'application_number', 'current_status', 'current_reviewer', 'submission_date', 'approved_date', 'new_document_flag'];
  public termsFields = ['status', 'current_status', 'content_type', 'sub_type'];
  public totalPermits: number;
  public items: any[];
  public showFilter = false;
  public filter: any = {isopen: false};
  @ViewChild(ResultsListComponent) resultsList: ResultsListComponent
  @ViewChild('filterMenu') filterMenu: NgbDropdown;

  public rowButtons = [
    {
      title: 'Review Permit',
      hideExpression: 'true',
      func: (item) => {
        // const meta = this.standbyService.meta;
        // meta.display_fields = ['fee', 'fee_paid', 'fee_paid_datetime', 'fee_payment_method',
        //     'fee_confirmation_number', 'fee_received_by', 'fee_proof'];
        // meta.type = 'applications/standby';
        // _item = angular.copy(item);
        // _item.globalid = _item.number;
        // delete item.generators;
        // delete item.organizations;
        // delete item.contacts;
        const modalInstance = this.modalService.open(SummaryModalComponent, {backdrop: 'static', size: 'lg'});
        modalInstance.componentInstance.item = item;
        modalInstance.componentInstance.reviewType = 'approval';
        // modalInstance.componentInstance.meta = meta;
        modalInstance.result.then(() => {
          this.resultsList.search();
        })
      }
    },
    {
      title: 'Print',
      hideExpression: 'item.content_type === 111',
      func: (application) => {
        window.open(`${environment.baseUrl}/standbygenerator/permits/${application.record_id}/get_application/`, '_blank');
      }
    }
  ];

  public rowIcons = [
    {
      title: 'New Documents',
      class: 'fa-file-text', // expects fontawesome icon class
      hideExpression: 'item.new_document_flag',
    }
  ];

  public columnIcons = {
    new_document_flag: {
      true: 'fa-file-text',
      false: ''
    }
  };

  public activeFilters: any;
  public typeChoices: any;
  public filteredStatus: any;
  private reviewId: string;
  private user: any;
  public subtypeChoices: any;

  constructor(private modalService: NgbModal,
              public reviewService: ReviewService, private route: ActivatedRoute,
              private authService: AuthService, private router: Router,
              private displayPipe: DisplayPipe, private datePipe: DatePipe) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.searchObj = this.parseStateParams(params);
      this.updateFilters(this.searchObj);
    })

    this.authService.getCurrentUser().subscribe(u => this.user = u)
    if (!this.searchObj.all_permits) {
      // add status to diplay fields for review queue
      this.displayFields.splice(4, 0, 'status');
    } else {
      // remove new document flag from diplay fields for permit queue
      this.displayFields.splice(8, 1);
    }
    this.reviewService.get<any>('counts').subscribe(response => {
      this.totalPermits = response.Total;
    });

    this.reviewService.loadMetadata().subscribe(() => {
      // this.filteredStatus = this.reviewService.meta.fields.status.choices.filter(c => c.value !== 'approved' || c !== 'not_needed')
      this.filteredStatus = this.reviewService.meta.fields.status.choices
      this.subtypeChoices = this.reviewService.meta.permit_subtypes
      this.reviewService.get<any>('permit_type').subscribe(response => {
        this.typeChoices = response;
        this.updateFilters(this.searchObj);
      });
    })
  }

  updateFilters(searchObj: any) {
    this.activeFilters = [];
    Object.keys(searchObj).forEach(key => {
      this.setActiveFilters(key, searchObj[key]);
    });
  }

  ngAfterViewInit(): void {
    if (this.searchObj.review_id) {
      this.reviewService.get<any>(this.searchObj.review_id).subscribe(res => {
        if (res.result !== undefined) {
          const modalInstance = this.modalService.open(SummaryModalComponent, {backdrop: 'static', size: 'lg'});
          modalInstance.result.finally(() => {
            //  remove the review_id param on close
            if (this.searchObj.review_id) {
              delete this.searchObj.review_id
              this.updateSearch();
            }
          });
          modalInstance.componentInstance.item = res.result;
          // modalInstance.componentInstance.meta = meta;
          // modalInstance.result.then(() => {
          //   this.resultsList.search();
          // })
        }
      })
    }
  }

  public updateCount(count) {
    this.metaCount = count;
  };

  public loadingStatus(status) {
    this.loading = status;
  }

  public clearFilters() {
    delete this.searchObj.next_reviewer;
    delete this.searchObj.content_type;
    delete this.searchObj.current_status__terms;
    delete this.searchObj.status__terms;
    delete this.searchObj.sub_type;
    delete this.searchObj.submission_date__lte;
    delete this.searchObj.submission_date__gte;
    delete this.searchObj.approved_date__lte;
    delete this.searchObj.approved_date__gte;
    this.updateSearch();
  };

  public clearFilter(key, value = null) {
    if (Array.isArray(this.searchObj[key])) {
      //  then update the searchObj value instead of delete
      this.searchObj[key] = this.searchObj[key].filter(x => x !== value)
    } else if (this.termsFields.includes(key)) {
      const vals = this.searchObj[key + '__terms'].split('__').filter(x => x !== value)
      if (typeof vals !== 'undefined' && vals.length > 0) {
        this.searchObj[key + '__terms'] = vals.join('__')
      } else {
        delete this.searchObj[key + '__terms']
      }
    } else {
      delete this.searchObj[key];
    }
    this.updateSearch();
  };


  private setActiveFilters(key, value) {
    if (key === 'next_reviewer') {
      this.activeFilters.push({
        type: key,
        display: `Next Reviewer: ${this.reviewService.meta.fields.reviewer.choices.find(c => c.value === value).display_name}`,
        value
      });
    } else if (key === 'current_user' && value && !this.searchObj.all_permits) {
      this.activeFilters.push({
        type: key,
        display: `Current User: ${this.displayPipe.transform(value, 'boolean')}`,
        value
      });
    } else if (key.includes('submission_date__gte') && value) {
      this.activeFilters.push({
        type: key,
        display: 'Submitted Date Begin: ' + this.datePipe.transform(value, 'yyyy-MM-dd'),
        value
      });
    } else if (key.includes('submission_date__lte') && value) {
      this.activeFilters.push({
        type: key,
        display: 'Submitted Date End: ' + this.datePipe.transform(value, 'yyyy-MM-dd'),
        value
      });
    } else if (key.includes('approved_date__gte') && value) {
      this.activeFilters.push({
        type: key,
        display: 'Approved Date Begin: ' + this.datePipe.transform(value, 'yyyy-MM-dd'),
        value
      });
    } else if (key.includes('approved_date__lte') && value) {
      this.activeFilters.push({
        type: key,
        display: 'Approved Date End: ' + this.datePipe.transform(value, 'yyyy-MM-dd'),
        value
      });
    } else if (key in this.reviewService.meta.fields || key.replace('__terms', '') in this.reviewService.meta.fields) {
      if (key.includes('__terms')) {
        // @ts-ignore
        value = value.split('__')
        key = key.replace('__terms', '');
      } else if (!Array.isArray(value)) {
        value = [value]
      }
      if (key === 'sub_type') {
        value.forEach(val => {
          this.activeFilters.push({
            type: key,
            display: `Permit Subtype: ${this.subtypeChoices?.find(c => c.value === val).display_name}`,
            value: val
          });
        })
      } else if (key === 'content_type') {
        value.forEach(val => {
          this.activeFilters.push({
            type: key,
            display: `Type: ${this.typeChoices.find(c => c.value === parseInt(value, 10)).display_name}`,
            value: val
          });
        })
      } else {
        value.forEach(val => {
          this.activeFilters.push({
            type: key,
            display: `${this.reviewService.meta.fields[key].label}: ${this.displayPipe.transform(val,
              this.reviewService.meta.fields[key].type === 'boolean' ? 'boolean' : this.reviewService.meta.fields[key].choices)}`,
            value: val
          })
        })
      }
    }
  }

  private parseStateParams(stateParams) {
    const newParams = {
      ordering: []
    };
    Object.keys(stateParams).filter(k => stateParams[k] != null).forEach(key => {
      const val = stateParams[key];
      newParams[key] = val === 'true' ? true : val === 'false' ? false : val;
    });
    return newParams
  }

  public updateSearch() {
    this.searchObj.page = 1;
    this.activeFilters = [];
    if ('current_user' in this.searchObj && this.searchObj.current_user && 'next_reviewer' in this.searchObj) {
      delete this.searchObj.next_reviewer;
    }
    Object.keys(this.searchObj).forEach(key => {
      this.setActiveFilters(key, this.searchObj[key]);
      if (this.termsFields.includes(key)) {
        const val = Array.isArray(this.searchObj[key]) ? this.searchObj[key].join('__') : this.searchObj[key]
        this.searchObj[key + '__terms'] = val;
        delete this.searchObj[key]
      }
    });
    if (this.searchObj.hasOwnProperty('submission_date__gte') && this.searchObj.submission_date__gte) {
      this.searchObj.submission_date__gte = this.datePipe.transform(this.searchObj.submission_date__gte, 'yyyy-MM-dd');
    }
    if (this.searchObj.hasOwnProperty('submission_date__lte') && this.searchObj.submission_date__lte) {
      this.searchObj.submission_date__lte = this.datePipe.transform(this.searchObj.submission_date__lte, 'yyyy-MM-dd');
    }
    if (this.searchObj.hasOwnProperty('approved_date__gte') && this.searchObj.approved_date__gte) {
      this.searchObj.approved_date__gte = this.datePipe.transform(this.searchObj.approved_date__gte, 'yyyy-MM-dd');
    }
    if (this.searchObj.hasOwnProperty('approved_date__lte') && this.searchObj.approved_date__lte) {
      this.searchObj.approved_date__lte = this.datePipe.transform(this.searchObj.approved_date__lte, 'yyyy-MM-dd');
    }
    // this.resultsList.search(true);
    this.router.navigate([], {queryParams: this.searchObj});
  }

  public updateFilter() {
    this.filterMenu.close();
    this.updateSearch();
  }
  public getRowColor(item) {
    if (item.current_status === 'approved') {
      return {'background-color': 'rgb(222 255 217)'};
    }
    const now = moment();
    const subDate = moment(item.submission_date);
    if (moment.duration(now.diff(subDate)).asDays() > 60) {
      return {'background-color': 'rgb(242 222 222)'};
    }
    if (moment.duration(now.diff(subDate)).asDays() > 30) {
      return {'background-color': 'rgb(252 248 227)'};
    }
    return {'background-color': 'none'};
  }
}
